import { useCallback, useState } from 'react';
import { sendWelcomeEmailToDiner } from 'src/common/features/DinersManagement/functions/sendWelcomeEmailToDiner';
import {
  SdkErrorResponse,
  pushErrorFromAPI,
  pushSuccess,
} from 'src/utilities/notifications';
import { IErrorResponse } from 'src/utilities/shared-types';

export type UseSendWelcomeEmailToDinerProps = {
  corpId: string;
  dinerId: string;
};

export type SendWelcomeEmailToDiner = (
  corpId: string,
  dinerId: string
) => Promise<void>;

export type UseSendWelcomeEmailToDinerReturn = {
  sendWelcomeEmail: SendWelcomeEmailToDiner;
  isLoading: boolean;
  sentWelcomeEmail: boolean;
};

export const useSendWelcomeEmailToDiner =
  (): UseSendWelcomeEmailToDinerReturn => {
    const [isLoading, setIsLoading] = useState(false);
    const [sentWelcomeEmail, setSentWelcomeEmail] = useState(false);

    const handleSuccess = async (): Promise<void> => {
      pushSuccess('Your welcome email was successfully sent.');
      setIsLoading(false);
      setSentWelcomeEmail(true);
    };

    const handleError = (error?: IErrorResponse | SdkErrorResponse): void => {
      pushErrorFromAPI(error, {
        fallbackMessage: 'Your welcome email was not sent. Try again.',
      });
      setIsLoading(false);
      setSentWelcomeEmail(false);
    };

    const sendWelcomeEmail = useCallback<SendWelcomeEmailToDiner>(
      async (corpId, dinerId) => {
        try {
          setIsLoading(true);

          await sendWelcomeEmailToDiner(corpId, dinerId);

          handleSuccess();
        } catch (error) {
          handleError(error);
        }
      },
      []
    );

    return {
      sendWelcomeEmail,
      isLoading,
      sentWelcomeEmail,
    };
  };
